import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin } from 'lucide-react';

export function Footer() {
  return (
    <footer className="bg-gray-50 border-t border-gray-200 py-12 sm:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 mb-12">
          <div className="col-span-2 lg:col-span-2">
            <Link to="/" className="inline-block mb-4">
              <img src="/logo.svg" alt="Situs Canada" className="h-8 w-auto" />
            </Link>
            <p className="text-sm text-gray-500 max-w-xs mb-6">
              Orca AI — Built for Canadian CPA document workflows.
            </p>
            <div className="flex items-center gap-4 text-gray-400">
              <a href="https://www.linkedin.com/company/situs-canada" target="_blank" rel="noopener noreferrer" className="hover:text-black transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-semibold text-gray-900 mb-4 text-sm">Product</h3>
            <ul className="space-y-3 text-sm text-gray-500">
              <li><Link to="/" className="hover:text-black transition-colors">Features</Link></li>
              <li><Link to="/pricing" className="hover:text-black transition-colors">Pricing</Link></li>
              <li><Link to="/security" className="hover:text-black transition-colors">Security review</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-gray-900 mb-4 text-sm">Solutions</h3>
            <ul className="space-y-3 text-sm text-gray-500">
              <li><Link to="/" className="hover:text-black transition-colors">For Accountants</Link></li>
              <li><Link to="/cra-reassessment-response" className="hover:text-black transition-colors">CRA reassessment</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-gray-900 mb-4 text-sm">Company</h3>
            <ul className="space-y-3 text-sm text-gray-500">
              <li><Link to="/about" className="hover:text-black transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-black transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-gray-900 mb-4 text-sm">Legal</h3>
            <ul className="space-y-3 text-sm text-gray-500">
              <li><Link to="/privacy" className="hover:text-black transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-black transition-colors">Terms of Service</Link></li>
              <li><Link to="/subprocessors" className="hover:text-black transition-colors">Sub-processors</Link></li>
              <li><Link to="/vulnerability-disclosure" className="hover:text-black transition-colors">Security review</Link></li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-200 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-500">
            &copy; {new Date().getFullYear()} Situs AI Inc. Montreal, Quebec, Canada.
          </p>
          <div className="flex items-center gap-6 text-sm text-gray-500">
            <Link to="/privacy" className="hover:text-black transition-colors">Privacy</Link>
            <Link to="/terms" className="hover:text-black transition-colors">Terms</Link>
            <a href="/.well-known/security.txt" className="hover:text-black transition-colors">security.txt</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
